import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./modalStyles.css";

const VideoModal = ({ open, onClose, urls }) => {
  const closeIcon = (
    <svg fill="currentColor" focusable="false" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M 14.144531 1.148438 L 9 6.292969 L 9 3 L 8 3 L 8 8 L 13 8 L 13 7 L 9.707031 7 L 14.855469 1.851563 Z M 8 8 L 3 8 L 3 9 L 6.292969 9 L 1.148438 14.144531 L 1.851563 14.855469 L 7 9.707031 L 7 13 L 8 13 Z"></path>
    </svg>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      closeIcon={closeIcon}
      classNames={{
        closeButton: "closeButton",
      }}
    >
      <video autoPlay controls muted loop playsInline>
        <source src={urls?.urlMp4} type="video/mp4" data-wf-ignore="true" />
        <source src={urls?.urlWebm} type="video/webm" data-wf-ignore="true" />
      </video>
    </Modal>
  );
};

export default VideoModal;
